import React from 'react';
export function useStorage(key, getStorage, defaultValue) {
    const [storage] = React.useState(getStorage);
    const getValue = () => (getJsonStorageItem(key, storage) ?? defaultValue);
    const [value, setValue] = React.useState(getValue);
    const updateValue = React.useCallback(() => setValue(getValue()), [key]);
    React.useEffect(() => {
        updateValue();
    }, [updateValue]);
    React.useEffect(() => {
        function eventListener(e) {
            if (e.key === key)
                updateValue();
        }
        window.addEventListener('storage', eventListener);
        return () => window.removeEventListener('storage', eventListener);
    }, [key, updateValue]);
    const setter = React.useCallback((newValue) => {
        const valueToStore = newValue instanceof Function ? newValue(value) : newValue;
        if (valueToStore == null) {
            storage?.removeItem(key);
        }
        else {
            setJsonStorageItem(key, valueToStore, storage);
        }
        setValue(valueToStore);
    }, [key, updateValue]);
    return [value, setter, updateValue];
}
function getJsonStorageItem(key, storage) {
    if (storage == null)
        return null;
    const item = storage.getItem(key);
    return item == null || item == '' ? item : safeJsonParse(item);
}
function setJsonStorageItem(key, value, storage) {
    if (storage == null)
        return;
    if (value == null)
        return storage.removeItem(key);
    const strValue = typeof value === 'string' ? value : JSON.stringify(value);
    storage.setItem(key, strValue);
}
function safeJsonParse(input) {
    if (input == null)
        return null;
    try {
        return JSON.parse(input);
    }
    catch {
        return input;
    }
}
